import type {
  Group,
  NodeGroupInterface,
  UnitInterface,
} from 'store/units/types';

export const isHighlighted = (
  unitKey: string,
  groupMap: Record<string, string>,
) => {
  return !!groupMap[unitKey];
};

export const findEmptyGroups = (
  units: UnitInterface[],
  groups: NodeGroupInterface,
) =>
  Object.values(groups).reduce((acc: Group[], curr) => {
    if (
      curr.unitKeys.length === 1 &&
      units.find((u) => u.key === curr.unitKeys[0])
    ) {
      return [...acc, curr];
    }
    return acc;
  }, []);
